import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, setPersistence, browserSessionPersistence } from "firebase/auth";
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import { getStorage } from "firebase/storage";

//Firebase configuration for things like Authentication, Database for user documents and answers then storage for any files uploaded.
const firebaseConfig1 = {
  apiKey: "AIzaSyAAH6DSuPLtvv1_gSwZhshsHTshjVTWRz4",
  authDomain: "trams-ai-v2.firebaseapp.com",
  projectId: "trams-ai-v2",
  storageBucket: "trams-ai-v2.firebasestorage.app",
  messagingSenderId: "1088193257602",
  appId: "1:1088193257602:web:ac3cb4c0e379f40d5f549b",
  measurementId: "G-C6KH7BPXS0"
};

const firebaseConfig2 = {
  apiKey: "AIzaSyB7QGcaMmwCAhf7uWK5zLSQi90fMkOkKeA",
  authDomain: "data-quality-3f674.firebaseapp.com",
  projectId: "data-quality-3f674",
  storageBucket: "data-quality-3f674.appspot.com",
  messagingSenderId: "868613399692",
  appId: "1:868613399692:web:3dbfe16e5631a7f8e807a9",
  measurementId: "G-DXFJFJDT2B"
};

const firebaseApp1 = !getApps().length ? initializeApp(firebaseConfig1) : getApp();

const firebaseApp2 = getApps().find(app => app.name === "secondary") 
  ? getApp("secondary") 
  : initializeApp(firebaseConfig2, "secondary");

const auth = getAuth(firebaseApp1);
const db = getFirestore(firebaseApp1);
const storage1 = getStorage(firebaseApp1); // Default storage
const storage2 = getStorage(firebaseApp2);





setPersistence(auth, browserSessionPersistence)
  .then(() => {
    console.log("Firebase session persistence set to session-only");
  })
  .catch((error) => {
    console.error("Error setting persistence:", error.message);
  });



export { auth, db, storage1, storage2 };
